import { ConstructClassWithPrivateMembers } from '../../helpers/ClassWithPrivateMembers';
import { IsObject } from '../../../helpers';
import { ADVANCED_ABORT_SIGNAL_PRIVATE } from './privates';
let ALLOW_ADVANCED_ABORT_SIGNAL_CONSTRUCT = false;
export function AllowAdvancedAbortSignalConstruct(allow) {
    ALLOW_ADVANCED_ABORT_SIGNAL_CONSTRUCT = allow;
}
export function ConstructAdvancedAbortSignal(instance, context) {
    if (ALLOW_ADVANCED_ABORT_SIGNAL_CONSTRUCT) {
        ConstructClassWithPrivateMembers(instance, ADVANCED_ABORT_SIGNAL_PRIVATE);
        const privates = instance[ADVANCED_ABORT_SIGNAL_PRIVATE];
        privates.context = context;
        privates.aborted = false;
        privates.reason = void 0;
    }
    else {
        throw new TypeError(`Illegal constructor`);
    }
}
export function IsAdvancedAbortSignal(value) {
    return IsObject(value)
        && (value.hasOwnProperty(ADVANCED_ABORT_SIGNAL_PRIVATE));
}
//# sourceMappingURL=constructor.js.map